<script>
import NestedCustomViewNode from './NestedCustomViewNode.vue';
import {
  buildCustomViewTree,
  buildLabelTree,
  filterCustomViewTree,
} from './customViewTree.mjs';

export default {
  components: { NestedCustomViewNode },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    kind: {
      type: String,
      default: 'view',
    },
    routeMode: {
      type: String,
      default: 'conversation',
    },
    showNewLabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: {},
      query: '',
    };
  },
  computed: {
    storageKey() {
      return `kanalio:chatwoot:${this.kind}-folders:${this.accountId}`;
    },
    tree() {
      return this.kind === 'label'
        ? buildLabelTree(this.items)
        : buildCustomViewTree(this.items);
    },
    visibleTree() {
      return filterCustomViewTree(this.tree, this.query);
    },
    searching() {
      return this.query.trim().length > 0;
    },
  },
  created() {
    if (typeof window === 'undefined') return;
    try {
      this.expanded = JSON.parse(window.localStorage.getItem(this.storageKey)) || {};
    } catch {
      this.expanded = {};
    }
  },
  methods: {
    toggle(folderId) {
      this.$set(this.expanded, folderId, !this.expanded[folderId]);
      window.localStorage.setItem(this.storageKey, JSON.stringify(this.expanded));
    },
  },
};
</script>

<template>
  <li class="mt-1">
    <div class="flex items-center justify-between px-2 pt-1 my-2 text-sm font-semibold text-slate-700 dark:text-slate-200">
      <span>
        {{ $t(kind === 'label' ? 'SIDEBAR.LABELS' : 'SIDEBAR.CUSTOM_VIEWS_FOLDER') }}
      </span>
      <woot-button
        v-if="showNewLabel"
        size="tiny"
        variant="clear"
        color-scheme="secondary"
        icon="add"
        class="p-0"
        @click="$emit('addLabel')"
      />
    </div>
    <label class="block px-1 mb-2">
      <span class="sr-only">Buscar carpetas o etiquetas</span>
      <input
        v-model.trim="query"
        type="search"
        :placeholder="kind === 'label' ? 'Buscar etiquetas…' : 'Buscar carpetas…'"
        class="w-full h-8 px-2 text-sm bg-white border rounded-md border-slate-200 text-slate-700 dark:bg-slate-900 dark:border-slate-700 dark:text-slate-100"
      />
    </label>
    <ul class="mb-0 ml-0 list-none">
      <NestedCustomViewNode
        v-for="node in visibleTree"
        :key="node.id"
        :account-id="accountId"
        :expanded="expanded"
        :node="node"
        :route-mode="routeMode"
        :searching="searching"
        @toggle="toggle"
      />
    </ul>
  </li>
</template>
